// Module
var code = `<div class="order-history-panel">
    <div class="order-history-panel-container-top">
        <rangeSelectPanel name='orderHistoryRangeSelect' />
    </div>

    <div class="order-history-panel-container-table">
        <terceraPanel name='windowPanelBodyQT' />
    </div>
</div>`;
// Exports
export default code;